<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "Confirm-Order",
        "hide-footer": "",
        centered: "",
        size: "800",
      },
      on: {
        hide: function ($event) {
          return _vm.onModalHidden(false)
        },
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _vm.data && _vm.data.coin
        ? _c("div", [
            _vm.data.coin
              ? _c(
                  "div",
                  {
                    staticClass:
                      "text-center d-flex justify-content-center head-top-25",
                  },
                  [
                    _c("span", { staticClass: "text-center pay-text" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("ConfirmOrderPop.ConfirmOrder")) +
                          " "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "text-center" }, [
              _c("div", { staticClass: "text-center recived-amt" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("ConfirmOrderPop.ReceiveAmount")) + " "
                ),
              ]),
              _c("div", { staticClass: "text-center amount-text" }, [
                _vm._v(
                  " " + _vm._s(_vm.data.amount + " " + _vm.data.coin) + " "
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "d-flex justify-content-between custom-line" },
              [
                _c("div", [_vm._v(_vm._s(_vm.$t("ConfirmOrderPop.Network")))]),
                _c("div", [_vm._v(_vm._s(_vm.data.network))]),
              ]
            ),
            _c(
              "div",
              { staticClass: "d-flex justify-content-between custom-line" },
              [
                _c("div", [_vm._v(_vm._s(_vm.$t("ConfirmOrderPop.Address")))]),
                _c(
                  "div",
                  { staticClass: "toAddress" },
                  [
                    _vm._v(" " + _vm._s(_vm.data.toAddress) + " "),
                    _c("Copy", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.v-primary",
                          modifiers: { hover: true, "v-primary": true },
                        },
                      ],
                      staticClass: "pointer copy_icon",
                      attrs: { title: _vm.$t("wallet.Copy") },
                      on: {
                        click: function ($event) {
                          return _vm.copy(_vm.item.value)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "d-flex justify-content-between custom-line" },
              [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("ConfirmOrderPop.WithdrawalAmount"))),
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm.data.quantity + " " + _vm.data.coin)),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "d-flex justify-content-between custom-line" },
              [
                _c("div", [
                  _vm._v(_vm._s(_vm.$t("ConfirmOrderPop.NetworkFee"))),
                ]),
                _c("div", [_vm._v(_vm._s(_vm.data.fee + " " + _vm.data.coin))]),
              ]
            ),
            _c(
              "div",
              { staticClass: "mt-1" },
              [
                _c("b-alert", { attrs: { variant: "primary", show: "" } }, [
                  _c("div", { staticClass: "info-card-r" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("ConfirmOrderPop.warningMessage-1")) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "info-card-r" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("ConfirmOrderPop.warningMessage-2")) +
                        " "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "text-center mt-1" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mb-1 mt-1 ok-w text-center",
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.apiCall()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("wallet.WithdrawPopButtonText")))]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/CancelOrder/ConfirmOrderPop.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import assets_rashi_coin_amt_eq_svg from '@/assets/rashi-coin/amt-eq.svg';
import assets_rashi_coin_copy_svg from '@/assets/rashi-coin/copy.svg';
import utils_clipboard from '@/utils/clipboard';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





export default ({
  render,
  staticRenderFns,
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"],
    AmtEq: assets_rashi_coin_amt_eq_svg,
    BAlert: bootstrapvue["BAlert"],
    Copy: assets_rashi_coin_copy_svg
  },
  data() {
    return {
      modalVisible: this.showPop
    };
  },
  directives: {
    "b-tooltip": bootstrapvue["VBTooltip"]
  },
  watch: {
    showPop(newValue) {
      this.modalVisible = newValue;
    }
  },
  methods: {
    async copy(text) {
      await utils_clipboard.apply(this, [`${text}`]);
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    showPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    onModalHidden: {
      type: Function,
      isRequired: true,
      default: () => {}
    },
    apiCall: {
      type: Function,
      isRequired: true,
      default: () => {}
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/CancelOrder/ConfirmOrderPop.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.model-800 {
  max-width: 840px;
}
.pay-text {
  font-size: 18px;
  color: var(--black);
}
[dir=ltr] .pay-text {
  padding-left: 25px;
  padding-right: 25px;
  float: left;
}
[dir=rtl] .pay-text {
  padding-right: 25px;
  padding-left: 25px;
  float: right;
}
[dir] .head-top-25 {
  margin-top: -15px;
}
.sm-p {
  color: var(--primary);
  font-size: 23px;
}
[dir] .sm-p {
  margin-top: 10px;
}
.ok-w {
  min-width: 30%;
}
.amount-text {
  font-weight: 500;
  font-size: 22px;
  color: var(--black);
}
[dir] .amount-text {
  margin-top: 5px;
  margin-bottom: 0px;
}
[dir] .recived-amt {
  margin-top: 10px;
}
.trx-fees {
  font-size: 11px;
}
[dir] .trx-fees {
  margin-bottom: 10px;
}
.toAddress {
  max-width: 65%;
  word-break: break-all;
}
[dir=ltr] .toAddress {
  text-align: right;
}
[dir=rtl] .toAddress {
  text-align: left;
}
.dark-layout .amt-eq path {
  fill: var(--white);
}
</style>
